import { useState } from 'react';
import { ChevronDown, ChevronUp, AlertTriangle, Pencil } from 'lucide-react';

interface UnknownAirportsPanelProps {
  codes: string[];
  onEdit: (code: string) => void;
}

export function UnknownAirportsPanel({ codes, onEdit }: UnknownAirportsPanelProps) {
  const [open, setOpen] = useState(false);

  if (codes.length === 0) return null;

  return (
    <div className="rounded-xl bg-amber-400/5 ring-1 ring-amber-400/20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 w-full px-4 py-3 text-left"
      >
        <AlertTriangle className="w-4 h-4 text-amber-400 shrink-0" />
        <div className="flex-1">
          <div className="text-xs font-medium text-amber-200">
            {codes.length} 个机场无坐标数据
          </div>
          <div className="text-[10px] text-amber-300/70 mt-0.5">点击展开,手工补录后航线即可显示</div>
        </div>
        {open ? (
          <ChevronUp className="w-3.5 h-3.5 text-amber-300/70" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5 text-amber-300/70" />
        )}
      </button>
      {open && (
        <ul className="px-4 pb-3 space-y-1.5">
          {codes.map((code) => (
            <li
              key={code}
              className="flex items-center justify-between bg-white/5 ring-1 ring-white/10 rounded-lg px-3 py-2"
            >
              <span className="font-mono text-sm tracking-wider text-slate-200">{code}</span>
              <button
                type="button"
                onClick={() => onEdit(code)}
                className="inline-flex items-center gap-1 text-xs text-cyan-300 hover:text-cyan-200 px-2 py-1 rounded-md hover:bg-cyan-400/10 ring-1 ring-cyan-400/20"
              >
                <Pencil className="w-3 h-3" />
                补录
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
